<template>
  <div class="chronology-action">
    <!-- USER AVATAR -->
    <div class="chronology-action__avatar">
      <avatar :person="actionInfo.creator" :size="avatarSize" />
    </div>

    <!-- DATE  -->
    <div class="chronology-action__date">{{ actionInfo.createdOn }}</div>

    <!-- VISIBILITY NOTE -->
    <div v-if="visibilityNote" class="chronology-action__visibility-note">
      <el-tooltip>
        <template #content>
          <div>{{visibilityNote}}</div>
        </template>
        <i class="ddi ddi-not-visible" />
      </el-tooltip>
    </div>

    <!-- ACTION -->
    <div class="chronology-action__action-text" v-html="actionInfo.action" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IChronologyAction } from '@/types/data-objects/item-histories'

export default defineComponent({
  name: 'ChronologyAction',

  props: {
    actionInfo: {
      type: Object as () => IChronologyAction,
      required: true,
    },
    visibilityNote: {
      type: String,
      default: '',
      required: false,
    },
  },
  computed: {
    avatarSize(): number {
      return this.$screen.isDesktop(this.$mq) ? 40 : 24
    },
  },
})
</script>

<style lang="scss">
.chronology-action {
  position: relative;
  padding-left: 33px;

  @include media-breakpoint-up(lg) {
    padding-left: 0.5 * $detail-gutter-pad-lg;
  }

  &__avatar {
    position: absolute;
    top: 6px;
    left: 0;

    @include media-breakpoint-up(lg) {
      top: 0;
    }
  }

  &__date {
    @include lettering--p-sm;
    color: var(--color-text-primary);
  }

  &__action-text {
    p {
      margin-bottom: 10px;
      word-break: break-word;
      @include lettering--p-md;

      a {
        @include lettering--normal-link;
      }
    }
  }

  &__visibility-note {
    position: absolute;
    @include lettering--p-sm;
    color: var(--color-text-third);
    top: -12px;
    right: 0;

    i {
      margin-right: 4px;
      font-size: 16px;
      line-height: 0;
    }

    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
}
</style>
